/**
 * Del Sol mega menu: anchors each promo panel under its menu trigger.
 *
 * Presentation only. Horizon's header-menu.js still owns open/close state, focus,
 * Escape handling and the submenu height; this script only sets the panel's inline
 * start margin so the card sits centered under its trigger (clamped to the header
 * content width). Without it the panel simply stays at the start edge.
 */
const PANEL_SELECTOR = '.delsol-mega-menu';
const ITEM_SELECTOR = '.menu-list__list-item';

/** @param {Element} item */
function placePanel(item) {
  const panel = item.querySelector(PANEL_SELECTOR);
  const inner = panel?.parentElement;
  if (!(panel instanceof HTMLElement) || !(inner instanceof HTMLElement)) return;

  const innerStyle = getComputedStyle(inner);
  if (innerStyle.direction === 'rtl') return;

  const trigger = item.querySelector(':scope > .menu-list__trigger') ?? item.querySelector(':scope > .menu-list__link');
  if (!trigger) return;

  const innerRect = inner.getBoundingClientRect();
  const triggerRect = trigger.getBoundingClientRect();
  const available = innerRect.width - parseFloat(innerStyle.paddingLeft) - parseFloat(innerStyle.paddingRight);
  const left = innerRect.left + parseFloat(innerStyle.paddingLeft);
  const width = Math.min(panel.offsetWidth || parseFloat(getComputedStyle(panel).width) || 0, available);
  if (!width) return;

  const centered = triggerRect.left + triggerRect.width / 2 - width / 2;
  const clamped = Math.min(Math.max(centered, left), left + available - width);
  panel.style.marginInlineStart = `${Math.round(clamped - left)}px`;
}

/** @param {Event} event */
function onActivate(event) {
  const target = event.target;
  const item = target instanceof Element ? target.closest(ITEM_SELECTOR) : null;
  if (item) requestAnimationFrame(() => placePanel(item));
}

let resizeFrame = 0;
function onResize() {
  cancelAnimationFrame(resizeFrame);
  resizeFrame = requestAnimationFrame(() => {
    document.querySelectorAll(ITEM_SELECTOR).forEach(placePanel);
  });
}

// Delegated, registered once, so it survives theme editor section re-renders.
const REGISTERED = Symbol.for('delsol.megaMenu');
if (!globalThis[REGISTERED]) {
  globalThis[REGISTERED] = true;
  document.addEventListener('pointerover', onActivate, { passive: true });
  document.addEventListener('focusin', onActivate);
  window.addEventListener('resize', onResize, { passive: true });
}
